import React from 'react';
import { PresetType } from '../../types';

interface HeaderProps {
  onPresetChange: (preset: PresetType) => void;
  currentPreset: PresetType | 'custom';
  showHalfOwnership: boolean;
  onOwnershipToggle: () => void;
  onReset: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  onPresetChange,
  currentPreset,
  showHalfOwnership,
  onOwnershipToggle,
  onReset
}) => {
  return (
    <header className="mb-8">
      {/* Title Section */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-xl font-medium text-gray-900 mb-1">
            Newport Beach House Decision
          </h1>
          <p className="text-sm text-gray-500">
            2040 Beryl Lane · Keep & Rent vs Sell & Invest
          </p>
        </div>
        <button
          onClick={onReset}
          className="text-sm text-gray-500 hover:text-gray-900 underline"
        >
          Reset
        </button>
      </div>

      {/* Controls Row */}
      <div className="flex flex-wrap items-center gap-6 pb-6 border-b border-gray-200">
        {/* Ownership Toggle */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Ownership:</span>
          <div className="inline-flex border border-gray-300">
            <button
              onClick={() => !showHalfOwnership || onOwnershipToggle()}
              className={`px-3 py-1 text-sm ${!showHalfOwnership ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}
            >
              Full
            </button>
            <button
              onClick={() => showHalfOwnership || onOwnershipToggle()}
              className={`px-3 py-1 text-sm border-l border-gray-300 ${showHalfOwnership ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}
            >
              50/50
            </button>
          </div>
        </div>

        {/* Scenario Presets */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Scenario:</span>
          <div className="inline-flex border border-gray-300">
            <button
              onClick={() => onPresetChange('rent')}
              className={`px-3 py-1 text-sm ${currentPreset === 'rent' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}
            >
              Favor Rent
            </button>
            <button
              onClick={() => onPresetChange('even')}
              className={`px-3 py-1 text-sm border-l border-gray-300 ${currentPreset === 'even' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}
            >
              Balanced
            </button>
            <button
              onClick={() => onPresetChange('sell')}
              className={`px-3 py-1 text-sm border-l border-gray-300 ${currentPreset === 'sell' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}
            >
              Favor Sell
            </button>
            {currentPreset === 'custom' && (
              <span className="px-3 py-1 text-sm border-l border-gray-300 bg-gray-100 text-gray-600">
                Custom
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
